import { render, staticRenderFns } from "./SideMenuUlComponent.vue?vue&type=template&id=46bd028d&"
import script from "./SideMenuUlComponent.vue?vue&type=script&lang=js&"
export * from "./SideMenuUlComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports